/**
 *  @class
 *  @function Pagination
 */

if (!customElements.get('pagination')) {
  class Pagination extends HTMLElement {
    constructor() {
      super();
      const id = this.dataset.section;
      this.button = this.querySelector('.load-more');
      this.grid = document.querySelector('[data-id=' + id + ']');
      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
      this.i = 2;
      this.scrollThreshold = window.innerHeight * 2;
      this.endPagination = false;
    }
    connectedCallback() {
      if (this.classList.contains('pagination-type--loadmore')) {
        this.loadMore();
      }
      if (this.classList.contains('pagination-type--infinite')) {
        this.infinite();
        this.setupScrollListener();
      }
    }
    addUrlParam(search, key) {
      var newParam = key + '=' + this.i,
        params = '?' + newParam;

      // If the "search" string exists, then build params from it
      if (search) {
        // Try to replace an existance instance
        params = search.replace(new RegExp('([?&])' + key + '[^&]*'), '$1' + newParam);

        // If nothing was replaced, then add the new param to the end
        if (params === search) {
          params += '&' + newParam;
        }
      }

      return params;
    }
    loadMore() {
      let base = this;
      this.button.addEventListener('click', function () {
        base.loadProducts();
        this.blur();
        return false;
      });
    }

    setupScrollListener() {
      window.addEventListener('scroll', () => {
        if (this.endPagination) return; // Stop scrolling if no more pages are available

        let scrollPosition = window.innerHeight + window.scrollY;
        let documentHeight = document.documentElement.scrollHeight;

        // Adjust the threshold to load much earlier
        if (documentHeight - scrollPosition < this.scrollThreshold) {
          if (!this.getAttribute('loading')) {
            console.log('load products!');
            this.loadProducts();
          } else {
            setTimeout(() => {
              if (!this.getAttribute('loading')) {
                console.log('load products loading!');
                this.loadProducts();
              }
            }, 200);
          }
        }
      });
    }

    infinite() {
      let base = this;
      let viewportHeight = window.innerHeight;
      base.observer = new IntersectionObserver(function (entries) {
        if (entries[0].intersectionRatio > 0) {
          base.saveHeightBeforeLoad();
          base.loadProducts();
          console.log('load products from infinite!');
        }
      }, {
        rootMargin: `${viewportHeight * 1.3}px`,
        threshold: 0.1
      });
      base.observer.observe(base);
    }

    saveHeightBeforeLoad() {
      let productGrid = document.querySelector('ul#product-grid');
      this.previousHeight = productGrid.scrollHeight;
    }

    loadProducts() {
      let base = this; // Preserve "this" reference

      // Prevent loading if already in progress or if all pages have been loaded
      if (base.getAttribute('loading') || base.endPagination) return;

      const progressElement = document.querySelector('.pagination--progress');
      const progressCount = progressElement
          ? parseFloat(getComputedStyle(progressElement).getPropertyValue('--progress-count'))
          : null;
      if (progressCount === 1.00) {
        base.endPagination = true;
        return;
      }

      let url = document.location.pathname + base.addUrlParam(document.location.search, 'page');
      base.i++;
      base.setAttribute('loading', true);

      const pagination_loader = document.querySelector('.pagination--wrapper .thb-filter-count .loading-overlay');
      if (pagination_loader) {
        pagination_loader.style.display = 'block'; // Show loader
      }

      fetch(url)
          .then(response => response.text())
          .then((responseText) => {
            const html = responseText;

            // Process new products
            base.renderProducts(html, url);

            // Dispatch event to notify page change
            dispatchCustomEvent('pagination:page-changed', { url: url });

            // Restore the scroll position after loading new products
            //base.restoreScrollAfterLoad();
          })
          .finally(() => {
            if (base.endPagination) {
              base.removeAttribute('loading'); // Ensure "loading" attribute is removed
            }
            if (pagination_loader) {
              pagination_loader.style.display = 'none';
            }
          });
    }

    restoreScrollAfterLoad() {
      const extraScroll = window.innerWidth < 767 ? 75 : 150;
      window.scrollTo(0, this.previousHeight + extraScroll);
    }


    renderProducts(html) {
      let base = this,
          parsed_html = new DOMParser().parseFromString(html, 'text/html'),
          grid_to_replace = parsed_html.getElementById('product-grid'),
          count_to_replace = parsed_html.getElementById('ProductCount');

      // Check if there are no more products to load
      if (!grid_to_replace || grid_to_replace.children.length === 0) {
        if (base.observer) {
          base.observer.unobserve(base); // Stop observing if no more pages are available
        }
        base.removeAttribute('loading');
        base.endPagination = true; // Mark pagination as completed
        if (base.button) {
          base.button.classList.add('visually-hidden'); // Hide the "Load More" button
        }
        return false; // Indicate that no more products are available
      }

      let products = grid_to_replace.querySelectorAll('.column');

      for (var i = 0; i < products.length; i++) {
        products[i].dataset.pagination = base.i;
        this.grid.appendChild(products[i]);
      }

      if (this.animations_enabled) {
        let added_columns = this.grid.querySelectorAll('[data-pagination="' + base.i + '"]'),
            to_animate = [];

        for (var j = 0; j < added_columns.length; j++) {
          to_animate[j] = added_columns[j].querySelector('.product-card .product-featured-image-link, .products .gallery--item figure');
        }
      }

      base.removeAttribute('loading');

      // Update product count display
      if (count_to_replace) {
        const container = document.getElementsByClassName('thb-filter-count');
        for (var item of container) {
          item.innerHTML = count_to_replace.innerHTML;
        }
      }

      return true; // Indicate that more products are available
    }

  }
  customElements.define('pagination-theme', Pagination);
}

